import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { boundsRegistry } from './bounds.js';
import { DebugView } from './DebugView.js';
import { DndAlly } from './DndAlly.js';
import cls from './DndRoot.module.css';
import { useDndStore } from './dndStore.js';
import { useMonitorGlobalGesture } from './gestureStore.js';
export function DndRoot({ children, debug, ...rest }) {
    const overlayRef = useDndStore((state) => state.domOverlayRef);
    const svgOverlayRef = useDndStore((state) => state.svgOverlayRef);
    useMonitorGlobalGesture();
    useEffect(() => boundsRegistry.setup(), []);
    return (_jsxs("div", { "data-role": "dnd-root", ...rest, children: [_jsx("div", { "data-role": "dnd-overlay", ref: overlayRef, className: cls.overlay }), _jsxs("svg", { "data-role": "dnd-svg-overlay", className: cls.svgOverlay, ref: svgOverlayRef, children: [_jsx("defs", { children: _jsx("clipPath", { id: "dnd-clip-path", children: _jsx("rect", { width: "100%", height: "100%" }) }) }), _jsx("g", { clipPath: "url(#dnd-clip-path)" })] }), children, debug && _jsx(DebugView, {}), _jsx(DndAlly, {})] }));
}
//# sourceMappingURL=DndRoot.js.map